<template>
    <div class="my-jobs-garden-help">

        <b-overlay :show="show_overlay" variant="success" :opacity=".5" rounded="sm" style="min-height:100%">
            <b-card no-body>
                <b-card-header>
                    <b-row>
                        <b-col lg="9" md="9">
                            <b-card-title class="card-title-garden-help">
                                Jobs </b-card-title>
                        </b-col>
                        <!-- <b-col lg="3" md="3" class="d-flex justify-content-end align-items-center">
                            <b-button variant="garden-help-info-light" class="btn-bumblebee btn-garden-help float-end"
                                disabled>
                                <font-awesome-icon icon="fa-solid fa-pen" /> Edit</b-button>
                        </b-col> -->
                    </b-row>
                    <b-row>
                        <b-col xl="6" lg="8" md="9">
                            <b-input-group class="input-group-search input-group-search-garden-help">
                                <template #prepend>
                                    <font-awesome-icon icon="fa-solid fa-magnifying-glass" size="lg" />
                                </template> <b-form-input v-model="search" class="form-control-garden-help"
                                    placeholder="Search job number or customer name"></b-form-input>
                            </b-input-group>
                        </b-col>
                        <!-- <b-col xl="6" lg="4" md="3">
                            <b-button variant="garden-help-filter-info" class="btn-bumblebee btn-garden-help float-right"
                                v-b-toggle.jobs-filter-sidebar><img
                                    src="@/assets/images/garden-help/filter-action-default-icon.png" /></b-button>
                        </b-col> -->
                    </b-row>
                </b-card-header>
                <b-card-body class="px-0">
                    <!-- <b-table class="gardenHelpTable" responsive :items="jobs" :fields="table_fields" details-td-class="text-center">
                <template #cell(created_at)="data" class="text-center">
                    <p class="dateTdSpan text-center">{{ data.value.substring(0, 9) }}</p>
                    <p class="text-center">{{ data.value.substring(10) }}</p>
                </template>
                <template #cell(scheduled_at)="data" class="text-center">
                    <p class="dateTdSpan text-center">{{ data.value.substring(0, 9) }}</p>
                    <p class="text-center">{{ data.value.substring(10) }}</p>
                </template>
            </b-table> -->

                    <b-table-simple class="gardenHelpTable" responsive stacked="md">
                        <b-thead>
                            <b-tr>
                                <b-th class="text-center">Created At</b-th>
                                <b-th class="text-center">Scheduled At</b-th>
                                <b-th>Job No.</b-th>
                                <b-th>Customer Name</b-th>
                                <b-th class="text-center">Location</b-th>
                                <b-th class="text-center">Description</b-th>
                                <b-th>Service Type</b-th>
                                <b-th class="text-center" v-if="type != 'requests'">Job Status</b-th>
                            </b-tr>
                        </b-thead>
                        <b-tbody v-if="jobs.length > 0">
                            <b-tr v-for="(job, index) in jobs" :key="index" @click="clickViewJob(job)">
                                <b-td stacked-heading="Created At" class="text-center">
                                    <p class="dateTdSpan">{{ job.created_at.substring(0, 9) }}</p>
                                    <p>{{ job.created_at.substring(10) }}</p>
                                </b-td>
                                <b-td stacked-heading="Scheduled At" class="text-center">
                                    <p class="dateTdSpan" v-if="job.details.booking_date_web">{{
                                        job.details.booking_date_web.substring(0, 9) }}</p>
                                    <p v-if="job.details.booking_date_web">{{ job.details.booking_date_web.substring(10) }}
                                    </p>
                                </b-td>
                                <b-td stacked-heading="Job No.">{{ job.order_id }}</b-td>
                                <b-td stacked-heading="Customer Name">{{ job.contact == null ? '' : job.contact.name
                                }}</b-td>
                                <b-td stacked-heading="Location" class="text-center">
                                    <img src="@/assets/images/garden-help/location-icon.png" :id="'location_' + job.id" />
                                    <b-popover custom-class="popover-garden-help" :target="'location_' + job.id"
                                        triggers="hover" placement="left">
                                        {{ job.location }}
                                    </b-popover>
                                </b-td>
                                <b-td stacked-heading="Description" class="text-center"><img
                                        src="@/assets/images/garden-help/document-desc-icon.png"
                                        :id="'description_' + job.id" />
                                    <b-popover custom-class="popover-garden-help" :target="'description_' + job.id"
                                        triggers="hover" placement="left">
                                        {{ job.description }}
                                    </b-popover></b-td>
                                <b-td stacked-heading="Service Type" class="serviceTd"
                                    v-html="getServicesNamesFromObject(job.orig_services)"></b-td>
                                <b-td stacked-heading="Job Status" class="text-center" v-if="type != 'requests'">
                                    <span :class="'jobStatusSpan ' + job.status + '_status'">{{
                                        getJobStatusClassAndStr(job.status) }}</span>
                                    <b-progress :value="getStatusPercentage(job.status)" :max="100"
                                        class="progress-garden-help my-2"></b-progress>
                                </b-td>
                            </b-tr>
                        </b-tbody>
                        <b-tbody v-else>
                            <b-tr>
                                <b-td :colspan="type == 'requests' ? 7 : 8" class="text-center cursor-initial">
                                    No results found
                                </b-td>
                            </b-tr>
                        </b-tbody>
                    </b-table-simple>
                    <!-- filter sidebar -->
                    <b-sidebar id="jobs-filter-sidebar" class="filter-sidebar-garden-help" title="Sidebar" right shadow
                        ref="sidebar_filter" :no-close-on-backdrop="false" :backdrop="true">
                        <div class="px-3 py-2">
                            <InputCheckboxFilter field_label="Service Categories" :options="servies_list"
                                :field_model.sync="service_filter" />

                            <!-- <b-form-group label="Distance" label-for="fulfilment_date"
                                label-class="form-label-filter-garden-help text-left ">
                                <vue-slider class="vue-slider-garden-help mt-3" v-model="distance" :min="0" :max="60"
                                    :interval="1" :dotSize="[22, 22]" height="8px" tooltip="always"
                                    :tooltip-formatter="'{value}km'"></vue-slider>
                            </b-form-group> -->

                            <!-- <InputCheckboxFilter field_label="Experience Level" :options="experience_levels_list"
                                :field_model.sync="experience_level_filter" /> -->

                            <InputCheckboxFilter field_label="Property Category" :options="property_types_list"
                                :field_model.sync="property_type_filter" />

                            <InputCheckboxFilter v-if="type == 'current'" field_label="Job Status" :options="status_list"
                                :field_model.sync="status_filter" />
                        </div>

                        <template #header="{ hide }">
                            <b-row class="w-100 mx-0">
                                <b-col cols="10" class="pl-0">
                                    <h2 class="filter-header w-100">
                                        <img src="@/assets/images/garden-help/filter-icon.png" /> Filter
                                    </h2>
                                </b-col>
                                <b-col cols="2" class="px-0" align-self="center">
                                    <b-button variant="garden-help-info-light"
                                        class="
                                                                                                                                btn-bumblebee btn-garden-help btn-close-action
                                                                                                                                d-block
                                                                                                                                float-right
                                                                                                                                m-auto
                                                                                                                              "
                                        @click="hide">x</b-button></b-col>
                            </b-row>
                        </template>
                        <template #footer>

                            <b-row class="p-2  w-100 m-auto" cols="2">
                                <b-col>
                                    <b-button variant="garden-help-primary" class="btn-bumblebee btn-garden-help"
                                        @click="clickFilter">Filter</b-button>
                                </b-col>
                                <b-col>
                                    <b-button variant="garden-help-light-outline" class="btn-bumblebee btn-garden-help"
                                        @click="clickClearFilters">Clear All</b-button>
                                </b-col>
                            </b-row>
                        </template>
                    </b-sidebar>

                </b-card-body>
            </b-card>
            <!-- pagination -->
            <b-card class="card-transparent-background m-0" no-body>
                <b-card-body class="px-2 py-0">
                    <b-row cols="1" cols-md="2">
                        <b-col>
                            <p class="data-list-info-garden-help">
                                Showing {{ from_page }} to {{ to_page }} of
                                {{ total_items }} entries
                            </p>
                        </b-col>
                        <b-col>
                            <b-pagination class="pagination-garden-help" v-model="currentPage" :total-rows="total_items"
                                :per-page="perPage" limit="7" @change="changePage" size="md"></b-pagination></b-col>
                    </b-row>
                </b-card-body>
            </b-card>
        </b-overlay>
    </div>
</template>

<script>
import axios from "axios";
import $ from "jquery";
import InputCheckboxFilter from "../../components/InputCheckboxFilter.vue";

import {
    getJobStatusClassAndStr, getStatusPercentage, listServicesRequest,
    listExperienceLevels,
    listPropertyTypes, getJobStatusListForFilter, getServicesNamesFromObject
} from "@/utils/helper-functions-garden-help.js"

export default {
    name: "StaffJobsTable",
    components: { InputCheckboxFilter },
    props: ["type","staff_id"],
    data() {
        return {
            show_overlay: false,
            client_name: "GARDENHELP",

            search: "",
            table_fields: [
                {
                    key: 'created_at',
                },
                {
                    key: 'scheduled_at',
                },
                {
                    key: 'job_number', label: "Job No."
                },
                {
                    key: 'customer_name',
                },
                {
                    key: 'location',
                },
                {
                    key: 'description',
                },
                {
                    key: 'service_type',
                },
                {
                    key: 'status', label: 'Job Status'
                },
            ],
            jobs: [

            ],
            // pagination
            perPage: 10,
            currentPage: 1,
            total_items: 0,
            from_page: 0,
            to_page: 0,
            // filter data
            servies_list: [],
            service_filter: [],
            experience_levels_list: [],
            experience_level_filter: [],
            property_types_list: [],
            property_type_filter: [],
            distance: 10,
            status_list: [],
            status_filter: []
        }
    },
    mounted() {

        console.log(this.type)
        this.getFilterData()

        this.getJobList(this.type)
    },
    watch: {
        search(newval) {
            console.log("search", this.search)
            this.getJobList(this.type)
        }
    },
    methods: {
        getJobStatusClassAndStr, getStatusPercentage, listServicesRequest,
        listExperienceLevels,
        listPropertyTypes, getJobStatusListForFilter,
        getServicesNamesFromObject,
        async getFilterData() {
            this.experience_levels_list = listExperienceLevels();
            this.property_types_list = listPropertyTypes();

            this.servies_list = await this.listServicesRequest(null);

            this.status_list = this.getJobStatusListForFilter()
        },
        changePage(value) {
            console.log("change page", value);
            this.currentPage = value
            this.getJobList(this.type)
        },
        clickClearFilters() {
            this.service_filter = [];
            this.experience_level_filter = [];
            this.property_type_filter = [];
            this.distance = 0;
            this.status_filter = []
        },
        clickFilter() {

            console.log("click filter")
            this.currentPage = 1

            console.log("Service", this.service_filter)
            // console.log("experience", this.experience_level_filter)
            console.log("type", this.property_type_filter)
            // console.log("distance", this.distance)
            console.log("status", this.status_filter)


            console.log(this.$refs.sidebar_filter)
            this.$refs.sidebar_filter.hide()
            this.getJobList(this.type)
        },
        clickViewJob(job) {
            this.$router.push({ name: "GardenHelpMyJobsJobDetails", params: { status: job.status, id: job.id } });
        },
        getJobList(type) {
            console.log("in get job lists", type, this.user_type, this.staff_id)
            this.show_overlay = true
            console.log(this.currentPage)
            let params_request = "?per_page=" + this.perPage + "&page=" + this.currentPage;
            console.log(params_request)


            if (this.search != null && this.search != "") {
                params_request += "&keyword=" + this.search
            }
            // if (this.user_type == 'operator') {
                params_request += "&operator_id="+this.staff_id
            // }
            params_request += "&status=pending,assigned,accepted,accepted_quote,on_route,arrived,in_progress,complete"


            if (this.property_type_filter.length > 0) {
                params_request += "&property_type=" + this.property_type_filter.toString()
            }
            if (this.service_filter.length > 0) {
                params_request += "&services=" + this.service_filter.toString()
            }

            console.log(params_request)

            axios
                .get("/jobs/jobs" + params_request, {
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                        client: this.client_name,
                        Authorization:
                            "Bearer " +
                            JSON.parse(window.localStorage.getItem("user")).access_token,
                    },
                })
                .then((response) => {
                    console.log(response)
                    console.log(response.data)
                    console.log(response)
                    this.jobs = response.data.data;

                    this.total_items = response.data.meta.total
                    if (response.data.meta.total == 0) {
                        this.from_page = 0
                        this.to_page = 0
                    } else {
                        this.from_page = ((this.currentPage - 1) * this.perPage) + 1
                        this.to_page = this.currentPage * this.perPage > response.data.meta.total ? response.data.meta.total : this.currentPage * this.perPage
                    }
                    this.show_overlay = false

                });
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/jobs/staff/JobsTable.vue